import React, { useCallback, useMemo, useState } from "react";
import { Platform } from "react-native";
import { Link as AuroraLink } from "@lookiero/aurora";
import { useI18nMessage, useI18n } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { I18nMessages } from "../../../../../../../i18n/i18n";
import { style as sizeGuideStyle } from "./SizeGuide.style";
import { getSizeGuideModalBySegmentAndTradename } from "./selectors/getSizeGuideModalBySegmentAndTradename";
const SizeGuide = ({ domain, i18nPrefix, portalHostName, segment, tradename, onOpenSizeGuide }) => {
    const style = useMemo(() => sizeGuideStyle(), []);
    const [visible, setVisible] = useState(false);
    const handleOnOpen = useCallback(() => {
        setVisible(true);
        onOpenSizeGuide?.();
    }, [onOpenSizeGuide]);
    const handleOnClose = useCallback(() => setVisible(false), []);
    const Link = useMemo(() => (Platform.OS === "web" ? AuroraLink : Text), []);
    const { formatMessage } = useI18n({ domain });
    const description = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_SUBTITLE,
        values: { segment: segment.toLowerCase() },
    });
    const descriptionLinkText = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_LINK,
        values: { segment: segment.toLowerCase() },
    });
    const descriptionLink = formatMessage({ id: `${i18nPrefix}${I18nMessages.SILHOUETTE_SIZES_GUIDE_DESCRIPTION}` }, {
        link: (React.createElement(Link, { level: 3, style: [style.description, style.link], testID: "size-guide-link", onPress: handleOnOpen }, descriptionLinkText)),
        segment: segment.toLowerCase(),
    });
    const Modal = useMemo(() => getSizeGuideModalBySegmentAndTradename({ segment, tradename }), [segment, tradename]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { level: 3, style: style.description }, description),
        React.createElement(Text, { level: 3, style: style.description }, descriptionLink),
        React.createElement(Modal, { domain: domain, i18nPrefix: i18nPrefix, portalHostName: portalHostName, segment: segment, visible: visible, onClose: handleOnClose })));
};
export { SizeGuide };
